import { Action, createReducer, on } from '@ngrx/store';

import * as DaigakuActions from '../actions/daigaku.actions';
import { Daigaku } from '../models/daigaku';
import { AppError } from '../errors/app-error';
import { DeleteDaigakuResponse } from '../models/delete-daigaku-response';

export const daigakuFeatureKey = 'daigaku';

export interface CreateDaigakuResult {
  success: boolean;
  createdDaigaku: Daigaku | null;
  error: AppError | null;
}

export interface UpdateDaigakuResult {
  success: boolean;
  updatedDaigaku: Daigaku | null;
  error: AppError | null;
}

export interface DeleteDaigakuResult {
  success: boolean;
  response: DeleteDaigakuResponse | null;
  error: AppError | null;
}

export interface State {
  daigaku: Daigaku | null;
  daigakus: Daigaku[] | null;
  createDaigakuResult: CreateDaigakuResult | null;
  updateDaigakuResult: UpdateDaigakuResult | null;
  deleteDaigakuResult: DeleteDaigakuResult | null;
}

export const initialState: State = {
  daigaku: null,
  daigakus: null,
  createDaigakuResult: null,
  updateDaigakuResult: null,
  deleteDaigakuResult: null
};

const daigakuReducer = createReducer(
  initialState,

  // Find Daigaku -------------------------------------------------------
  on(DaigakuActions.findDaigakuSuccess, (state, { daigaku }) => ({ ...state, daigaku })),
  on(DaigakuActions.initializeFindDaigakuState, state => {
    const next: State = { ...state, daigaku: null };
    return next;
  }),

  // Find Daigakus -------------------------------------------------------
  on(DaigakuActions.findDaigakusSuccess, (state, { daigakus }) => ({ ...state, daigakus })),
  on(DaigakuActions.initializeFindDaigakusState, state => {
    const next: State = { ...state, daigakus: null };
    return next;
  }),

  // Create Daigaku ----------------------------------------------------------------
  on(DaigakuActions.createDaigakuSuccess, (state, { daigaku }) => {
    const next: State = {
      ...state,
      createDaigakuResult: { success: true, createdDaigaku: daigaku, error: null }
    };
    return next;
  }),
  on(DaigakuActions.createDaigakuFailure, (state, { error }) => {
    const next: State = {
      ...state,
      createDaigakuResult: { success: false, createdDaigaku: null, error }
    };
    return next;
  }),
  on(DaigakuActions.initializeCreateDaigakuState, state => {
    const next: State = { ...state, createDaigakuResult: null };
    return next;
  }),

  // Update Daigaku ----------------------------------------------------------------
  on(DaigakuActions.updateDaigakuSuccess, (state, { daigaku }) => {
    const next: State = {
      ...state,
      updateDaigakuResult: { success: true, updatedDaigaku: daigaku, error: null }
    };
    return next;
  }),
  on(DaigakuActions.updateDaigakuFailure, (state, { error }) => {
    const next: State = {
      ...state,
      updateDaigakuResult: { success: false, updatedDaigaku: null, error }
    };
    return next;
  }),
  on(DaigakuActions.initializeUpdateDaigakuState, state => {
    const next: State = { ...state, updateDaigakuResult: null };
    return next;
  }),

  // Delete Daigaku ----------------------------------------------------------------
  on(DaigakuActions.deleteDaigakuSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      deleteDaigakuResult: { success: true, response, error: null }
    };
    return next;
  }),
  on(DaigakuActions.deleteDaigakuFailure, (state, { error }) => {
    const next: State = {
      ...state,
      deleteDaigakuResult: { success: false, response: null, error }
    };
    return next;
  }),
  on(DaigakuActions.initializeDeleteDaigakuState, state => {
    const next: State = { ...state, deleteDaigakuResult: null };
    return next;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return daigakuReducer(state, action);
}
